import React from "react";
import * as Yup from 'yup';
import { CompanyDataDto } from "../../generated"
import { Forms } from "../../common/components/CmForms";
const { Form, FormText, ActionBar } = Forms<CompanyDataDto>()

interface Props {
    esercente?: CompanyDataDto;
    onSubmit: (customer: CompanyDataDto) => void;
    onCancel: () => void;
}

export default class EsercenteForm extends React.Component<Props> {

    private static validationSchema = Yup.object<Partial<CompanyDataDto>>({
        ragioneSocialeEsercente: Yup
            .string()
            .required('Campo obbligatorio'),
        codiceFiscaleEsercente: Yup
            .string()
            .required('Campo obbligatorio'),
        indirizzoEsercente: Yup
            .string()
            .required('Campo obbligatorio'),
        cittaEsercente: Yup
            .string()
            .required('Campo obbligatorio'),
        capEsercente: Yup
            .string()
            .required('Campo obbligatorio'),
        provinciaEsercente: Yup
            .string()
            .required('Campo obbligatorio'),
        telMobileEsercente: Yup
            .string()
            .required('Campo obbligatorio'),
        emailEsercente: Yup
            .string()
            .email("deve essere una casella di posta elettronica")
            .required('Campo obbligatorio'),
        pec: Yup
            .string()
            .email("deve essere una casella di posta elettronica")
            .required('Campo obbligatorio'),
        sdi: Yup
            .string()
            .required('Campo obbligatorio'),
    })

    render() {
        const { esercente, onCancel } = this.props;
        if (!esercente)
            return null;

        return (
            <Form
                onSubmit={this.props.onSubmit}
                initialValues={esercente}
                validationSchema={EsercenteForm.validationSchema}
            >
                <>
                    <div className="row">
                        <div className="col-12 col-md-6">
                            <FormText
                                label="Ragione sociale:"
                                name="ragioneSocialeEsercente"
                            />
                        </div>
                        <div className="col-12 col-md-6">
                            <FormText
                                label="P.IVA:"
                                name="partitaIvaEsercente"
                                readOnly
                            />
                        </div>
                        <div className="col-12 col-md-6">
                            <FormText
                                label="Codice fiscale:"
                                name="codiceFiscaleEsercente"
                            />
                        </div>
                        <div className="col-12 col-md-6">
                            <FormText
                                label="Indirizzo:"
                                name="indirizzoEsercente"
                            />
                        </div>
                        <div className="col-12 col-md-6">
                            <FormText
                                label="Città:"
                                name="cittaEsercente"
                            />
                        </div>
                        <div className="col-12 col-md-6">
                            <FormText
                                label="Provincia:"
                                name="provinciaEsercente"
                            />
                        </div>
                        <div className="col-12 col-md-6">
                            <FormText
                                label="Cap:"
                                name="capEsercente"
                            />
                        </div>
                        <div className="col-12 col-md-6">
                            <FormText
                                label="Tel Fisso:"
                                name="telFissoEsercente"
                            />
                        </div>
                        <div className="col-12 col-md-6">
                            <FormText
                                label="Tel Mobile:"
                                name="telMobileEsercente"
                            />
                        </div>
                        <div className="col-12 col-md-6">
                            <FormText
                                type="email"
                                name="pec"
                                label="Pec"
                            />
                        </div>
                        <div className="col-12 col-md-6">
                            <FormText
                                name="sdi"
                                label="Codice Univoco"
                            />
                        </div>
                        <div className="col-12 col-md-6">
                            <FormText
                                label="Email:"
                                name="emailEsercente"
                            />
                        </div>
                        <div className="col-12 col-md-6">
                            <FormText
                                label="Link logo:"
                                name="linkLogoEsercente"
                            />
                        </div>
                    </div>
                    <ActionBar alwaysActive
                        onCancel={onCancel}
                    />
                </>
            </Form>
        );
    }
}
